var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"second-title"},[(_vm.titleImg)?_c('img',{attrs:{"src":_vm.titleImg}}):_c('span'),_vm._v(" "+_vm._s(_vm.secTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }